import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

const Sucesso = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-white px-4">
      <div className="max-w-xl w-full text-center">
        <div className="flex justify-center mb-6">
          <CheckCircle2 className="w-16 h-16 text-green-600" />
        </div>
        <h1 className="text-3xl font-bold mb-2">
          Mensagem enviada com sucesso
        </h1>
        <p className="text-gray-600 mb-8">
          Recebemos sua mensagem e entraremos em contato em breve. Obrigado por
          falar com a VA Recuperação.
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center px-6 py-3 rounded-lg text-white font-medium"
          style={{
            background:
              "linear-gradient(135deg, #F22E3E 0%, #BF2431 50%, #F20505 100%)",
          }}
        >
          Voltar para a página inicial
        </Link>
      </div>
    </div>
  );
};

export default Sucesso;
